<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="550"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Sync from WMS</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column mx-5 py-7">
        <!-- Type Dropdown -->
        <div class="min-h-75px">
          <v-autocomplete
            v-model="formData.type"
            :items="syncTypes"
            item-text="text"
            item-value="index"
            label="Type"
            dense
            outlined
            clearable
            :error-messages="typeErrors"
            @blur="$v.formData.type.$touch()"
          />
        </div>

        <!-- Date Range -->
        <div class="min-h-75px">
          <DateRangePicker
            @on-submit="getDateRange"
            :errorMessages="dateRangeErrors"
            :onBlur="() => $v.formData.date_range.$touch()"
          />
        </div>

        <!--begin::Actions-->
        <div
          class="my-4 min-h-75px d-flex flex-grow-1 align-end justify-center"
        >
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import DateRangePicker from "@/own/components/finance/invoices/DateRangePicker.vue";
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "SyncFromWMS",
  components: { DateRangePicker },
  mixins: [validationMixin],
  validations: {
    formData: {
      type: { required },
      date_range: { required },
    },
  },
  data: () => ({
    dialog: false,
    formData: {
      type: null,
      date_range: null,
    },
  }),
  computed: {
    syncTypes() {
      return this.$store.getters.getINVOICESSyncTypes || [];
    },
    typeErrors() {
      return this.handleFormValidation("type");
    },
    dateRangeErrors() {
      return this.handleFormValidation("date_range");
    },
  },
  methods: {
    toggleModal() {
      this.resetFormData();
      this.dialog = !this.dialog;
    },
    getDateRange(val) {
      this.formData.date_range = val;
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post(`/cod/invoices/sync_additional_services`, {
        type: this.formData.type,
        start_date: this.formData.date_range[0],
        end_date: this.formData.date_range[1],
      })
        .then(({ data }) => {
          if (data?.success) {
            Swal.fire(
              "Success!",
              data?.message ?? "Sync initiated successfully!",
              "success"
            );
            this.toggleModal();
          }
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    resetFormData() {
      this.$v.$reset();
      this.formData = { type: null, date_range: null };
    },
  },
};
</script>
